import '../../css/fx.scss'
import '../../css/loading.scss'

import $ from 'jquery'
import _ from 'lodash'
import {Libs, extension, FX} from 'eyes-lib/es'
import * as Store from './store'
import {Translate} from './multi-lang'

const {App} = Store
const {Ajax, TXT, getGlobal, trim, nvl, toInt} = Libs

/**
 * 全ページで使用する共通ファンクション
 */

/** IE8のpolyfill有効化 */
// extension.ie8()

/** bluebird対策有効化 */
// extension.bluebird.fix()

/** Boolean拡張有効化 */
extension.boolean.val()

/** lodash拡張有効化 */
extension.lodash.basic()

/** jQuery拡張有効化 */
extension.jquery.nvl() //$('#hoge').val()にnvl合わせた機能を有効化
extension.jquery.intVal() //$('#hoge').val()にnvl+toIntを合わせた機能を有効化
extension.jquery.selfHtml() //自身のタグを含めたhtmlタグを取得するプラグイン有効化
extension.jquery.event() //イベント登録を先頭に割り込ませるプラグイン有効化
extension.jquery.disabled() //selectタグをdisable化するプラグイン有効化

/**
 * jQueryセレクタのエスケープ処理
 * @param {string} selector 
 */
function escAst(selector){
	return selector.replace(/[ $%*\/;?@\\{|}]/g, '\\$&')
}

/** ツアーデータを表示する共通関数 */
/**
 * @param {import('./store.js').Shohin} shohin
 */
const dispTourTitle = shohin => {
	if( !shohin ) return ; //! EXIT

	$("#tourname").text(shohin.shohin_name);
	$("#toursubtitle").text(shohin.shohin_subtitle);
	$("#tourcode").text(shohin.shohin_code);
	$("#tourfromdate").text(shohin.from_date);
	$("#tourtodate").text(shohin.to_date);
	$("#tourprice").text( Libs.currency(shohin.total_price))

	/** 金額が0円の場合は枠事表示しない */
	if(shohin.total_price==0)
	{
		$(".NowPrice").hide();
	}

}

/** セッションストレージに保存するためのキーを作成 */
const getUniquKey = () => {
	const address = location.href.split("/")

	if(location.href.indexOf("domtour/_tin") >= 0){
		return `${address[7]}_${address[8]}_${address[9]}`
	}else{
		return `${address[6]}_${address[7]}_${address[8]}`
	}
}

/**
 * Passengerリストから合計値を求める
 * @description paxtypeで分けてcountの値をsumする関数
 * @param {import('./store').Passenger[]} passengerList
 * @param {0|1|2|"0"|"1"|"2"} [type] - 0:大人 | 1:小人 | 2:幼児
 */
function countPassenger(passengerList, type = null)
{
	/** 
	 * 各値の合計値を算出するlodash(chain)オブジェクトを作成
	 * 遅延評価を利用するので、計算コストは最後の判定ブロックにて決定
	 */
	const adult = _.chain( passengerList )
			.filter( val => {
				return val.passenger_paxtype === 0 || val.passenger_paxtype === '0'
			  })
			.sumBy( 'passenger_count' )

	const child = _.chain( passengerList )
			.filter( val => {
				return val.passenger_paxtype === 1 || val.passenger_paxtype === '1'
			})
			.sumBy( 'passenger_count' )

	const infant = _.chain( passengerList )
			.filter( val => {
				return val.passenger_paxtype === 2 || val.passenger_paxtype === '2'
			})
			.sumBy( 'passenger_count' )

	/** paxtypeの数値とインデックス値を合わせた配列を作成 */
	const sumData = [ adult, child, infant ]

	if( type == null )
	{
		/** value()で遅延評価し、その合計値を返す */
		return _.sumBy( sumData, data => {
			return data.value()
		} )
	}
	else
	{
		/** value()で遅延実行 */
		return _.get( sumData, type ).value()
	}
}

/**
 * Passengerリストから大人のcountだけを合算
 * @param {import('./store').Passenger[]} passengerList
 */
function countAdult(passengerList){
	return countPassenger( passengerList, 0 )
}

/**
 * Passengerリストから子供のcountだけを合算
 * @param {import('./store').Passenger[]} passengerList
 */
function countChild(passengerList){
	return countPassenger( passengerList, 1 )
}

/**
 * Passengerリストから幼児のcountだけを合算
 * @param {import('./store').Passenger[]} passengerList
 */
function countInfant(passengerList){
	return countPassenger( passengerList, 2 )
}

/**
 * Passengerリストから子供(添寝を含まない)のcountだけを合算
 * @param {import('./store').Passenger[]} passengerList
 */
function countChildNoSoine(passengerList){
	const child = _.chain( passengerList )
			.filter( val => {
				return (val.passenger_paxtype === 1 || val.passenger_paxtype === '1') && (val.passenger_soineflag=='0')
			})
			.sumBy( 'passenger_count' )

	/** paxtypeの数値とインデックス値を合わせた配列を作成 */
	const sumData = [ child ]

	return _.get( sumData, 0 ).value()
}







/** 画面エフェクト関数 */
const fx = {
	/**
	 * ローディング画面開始
	 * @param {LoadingOption} [options]
	 */
	loadingStart: function(options)
	{
		/** @type {LoadingOption} */
		const opt = _.merge( {
			type: 'spin',
			background: 'rgba(255, 255, 255, 0.76)',
			fade: 600,
		}, options )
		return FX.loadingStart(opt)
	},

	/** ローディング画面停止 */
	loadingEnd: FX.loadingEnd,
}
_.set(getGlobal(), 'fx', fx )

/** 表示関数 */
const disp = {
	/** @param {string[]} code */
	tourCode : function(...code){
		return _.join(code, '-')
	},
	/**
	 * ○泊○日表示用関数
	 * @description 0泊0日と0泊1日は`日帰り`で返す
	 * @param {number|string} _haku - 泊
	 * @param {number|string} _day - 日数
	 */
	hakuDay : function (_haku = 0, _day = 0) {
		const [haku, day] = [ toInt(_haku), toInt(_day) ]
		/** 日数がないなら日帰り */
		if( haku === 0 ) return `日帰り` //!EXIT

		let text = ''
		if( haku > 0 ) text += `${haku}泊`
		if( day > 0 ) text += `${day}日`
		return text
	},

	/**
	 * #### 日付文字を整形表示
	 * 日付文字は8桁（年月日）、6桁（年月）、4桁（月日）に対応
	 * @param {string} val 20150321 | 201503 | 0315
	 * @param {string} [mark='/'] 区切り記号
	 */
	dateStrFormat: function(val = '', mark = '/'){
		if( _.size( val ) === 8 )
			return `${val.substr(0,4)}${mark}${val.substr(4,2)}${mark}${val.substr(6,2)}`
		else if( _.size( val ) === 6 )
			return `${val.substr(0,4)}${mark}${val.substr(4,2)}`
		else if( _.size( val ) === 4 )
			return `${val.substr(0,2)}${mark}${val.substr(2,2)}`
	},

	/**
	 * #### 金額表示関数
	 * 数値をカンマ区切り文字列に変換
	 * @description Libs.currencyのalias
	 * @param {string|number} value 金額数値
	 * @param {string|boolean} [mark=false] 単位記号
	 * @see Libs.currency
	 */
	currency: Libs.currency,

}

/** お気に入り機能 */
const fav = {
	/** お気に入り最大保存件数 */
	MAX: 10,

	/**
	 * お気に入り保存用のキー名を取得
	 * @description オブジェクトが渡ってきたらtourcodeプロパティまたはcode123プロパティと営業所でID作成。
	 * 直接引数で(tourcode, branchcode)または(code1,code2,code3,branchcode)でもID作成できます。
	 * @example
	 *   getFavoriteID( {
	 *     tourcode:'AA-0001-000001',
	 *     branchcode: '20',
	 *   })
	 *   getFavoriteID( {
	 *     code1:'AA',
	 *     code2:'0001',
	 *     code3:'000001',
	 *     branchcode: '20',
	 *   })
	 *   getFavoriteID( 'AA-0001-000001', '20')
	 *   getFavoriteID( 'AA', '0001', '000001', '20')
	 * @param { {branchcode:string,tourcode:string} | {branchcode:string,cod1:string,cod2:string,cod3:string} | string} arg1
	 * @param {string} [arg2]
	 * @param {string} [arg3]
	 * @param {string} [arg4]
	 */
	getFavoriteID: function (arg1, arg2 = null, arg3 = null, arg4 = null)
	{
		/** 引数が１つで、それが純粋なオブジェクトならば */
		if( _.isPlainObject( arg1 ) && _.isNil(arg2) )
		{
			const item = arg1
			/** ツアーコード求める */
			const tourcode = (()=>{
				if( _.has( item, 'tourcode' ) )
				{
					return _.get(item, 'tourcode')
				}
				else if( _.has( item, 'code1' ) && _.has( item, 'code2' ) && _.has( item, 'code3' ) )
				{
					return `${_.get( item, 'code1' )}-${_.get( item, 'code2' )}-${_.get( item, 'code3' )}`
				}
			})()

			/** 営業所コード取得 */
			const branchcode = _.get(item, 'branchcode')
			return `Favorite_${tourcode}_${branchcode}` //!EXIT
		}
		else if( _.isString( arg1 ) && _.isString( arg2 ) && _.isString( arg3 ) && _.isString( arg4 ) )
		{
			/** 引数が４つならcode123と営業所コードと判断 */
			return `Favorite_${arg1}-${arg2}-${arg3}_${arg4}` //!EXIT
		}
		else if( _.isString( arg1 ) && _.isString( arg2 ) )
		{
			/** 引数が２つならツアーコードと営業所コードと判断 */
			return `Favorite_${arg1}_${arg2}` //!EXIT
		}

		throw new Error('Favorite ID Error')
	},
	/**
	 * 指定の商品がお気に入り登録されているかチェック
	 * @example
	 *   hasFavoriteData( {
	 *     tourcode:'AA-0001-000001',
	 *     branchcode: '20',
	 *   })
	 *   hasFavoriteData( {
	 *     code1:'AA',
	 *     code2:'0001',
	 *     code3:'000001',
	 *     branchcode: '20',
	 *   })
	 *   hasFavoriteData( 'AA-0001-000001', '20')
	 *   hasFavoriteData( 'AA', '0001', '000001', '20')
	 * @param { {branchcode:string,tourcode:string} | {branchcode:string,cod1:string,cod2:string,cod3:string} | string} arg1
	 * @param {string} [arg2]
	 * @param {string} [arg3]
	 * @param {string} [arg4]
	 * @returns {boolean}
	 */
	hasFavoriteData: function( arg1, arg2 = null, arg3 = null, arg4 = null){
		/** 配列にする */
		const args = [arg1, arg2, arg3, arg4]

		/** キー名取得 */
		const keyID = fav.getFavoriteID.apply( null, _.filter(args, arg =>{
			/** オブジェクトと文字列だけgetFavoriteIDにapplyで投げる */
			return _.isString(arg) || _.isPlainObject(arg)
		}) )
		return !! App.storage.getItem( keyID )
	},

	/**
	 * 保存されているお気に入り件数情報など取得
	 */
	getFavoriteCountInfo: function (){

		/** 全ストレージ取得 */
		const dataList = App.storage.load()
		const size = _.reduce( dataList, (acc, v, k) =>
		{
			/** お気に入り商品用のストレージをカウント */
			if( k.startsWith('Favorite') ) acc++
			return acc
		}, 0 )
		
		return {
			/** 最大お気に入り保存件数 */
			max: fav.MAX,
	
			/** 保存中のお気に入り件数 */
			size: size,
		}
	},

	/**
	 * お気に入り登録
	 * @param {import('./store').DetailData} item
	 * @param {(err:'already'|'max'|'', data?:{max:number,size:number})=>void} [callback]
	 */
	addFavoriteData: function ( item, callback = null )
	{
		/** @type {'already'|'max'|''} */
		let isErr = ''
		const favCnt = fav.getFavoriteCountInfo()
	
		/** 登録処理していい？ */
		if(favCnt.size < favCnt.max)
		{
			/** キー取得 */
			const keyID = fav.getFavoriteID(item)

			const hasItem = App.storage.getItem( keyID )
			if( hasItem )
			{
				isErr = 'already'
			}
			
			/** 保存 */
			App.storage.setItem(keyID, item)
		}
		else
		{
			isErr = 'max'
		}
		
		/** コールバック関数が設定されているか？ */
		const hasCallback = _.isFunction( callback )
		if( hasCallback )
			return callback(isErr, favCnt)
		else
			return !!isErr
	
	},

	/**
	 * 指定の商品をお気に入りから削除
	 * 引数に関数を入れれば、コールバック関数としても使えます
	 * @param { {branchcode:string,tourcode:string} | {branchcode:string,cod1:string,cod2:string,cod3:string} | string} arg1
	 * @param {string | ((err:boolean)=>void) } [arg2]
	 * @param {string | ((err:boolean)=>void)} [arg3]
	 * @param {string} [arg4]
	 * @param {(err:boolean)=>void} [arg5]
	 * @example
	 *   delFavoriteData({tourcode:'AA-0001-000001', branchcode: '20'})
	 *   delFavoriteData({code1:'AA', code2:'0001', code3:'000001', branchcode: '20'})
	 *   delFavoriteData('AA-0001-000001', '20')
	 *   delFavoriteData('AA', '0001', '000001', '20')
	 *   delFavoriteData(shohin, function(err){} )
	 *   delFavoriteData('AA', '0001', '000001', '20', function(err){} )
	 */
	delFavoriteData: function ( arg1, arg2 = null, arg3 = null, arg4 = null, arg5 = null )
	{
		let isErr = false
		/** 配列にする */
		const args = [arg1, arg2, arg3, arg4, arg5]

		/** コールバックを探す */
		const callback = _.find( args, _.isFunction )

		/** キー名取得 */
		const keyID = fav.getFavoriteID.apply( null, _.filter(args, arg =>{
			/** オブジェクトと文字列だけgetFavoriteIDにapplyで投げる */
			return _.isString(arg) || _.isPlainObject(arg)
		}) )

		if( _.isString( keyID ) )
		{
			//削除処理
			App.storage.removeItem( keyID )
		}
		else
		{
			isErr = true
		}

		if( _.isFunction( callback ) )
			return callback(isErr)
		else
			return !isErr
	},
	/**
	 * お気に入りデータをクラスにパックする
	 * @description お気に入りページへ遷移させるためにfavoriteCartオブジェクトが必要なため、主にそれ用
	 */
	packFavoriteData: function(){
		/** @type {import("./store").FavoriteCartData} 詳細情報 */
		const favoriteCart = Store.FavoriteCartData.new()

		/** @type {import("./store").DetailData[]} 詳細情報 */
		const favoriteList = []

		/** @type {Object.<string, any>} ストレージ全部 */
		const dataList = Store.App.storage.load()

		_.each(dataList,  function(value, key){

			/** 最近見たツアー用のストレージを抜粋 */
			if(key.indexOf("Favorite") >= 0){
				/** @type {import("./store").DetailData} 詳細情報 */
				const fovoriteData = value

				//リストに登録
				favoriteList.push(fovoriteData)
			}
		} );
		favoriteCart.favorite = favoriteList
		return favoriteCart
	}
}

/** APIエラー */
class ApiError extends Error {
	constructor(status, ...params) {
		super(...params)
		this.name = 'ApiError'
		this.status = status
	}
}

/**
 * APIデータ取り出し (status==okの場合にitemsの中身取得)
 * @description 最低限のパース＆エラーチェックも実施
 * @param {{status:'ok'|'ng'|'error'|'unauthorized', items:any}} res
 */
const fetchItem = function fetchItem(res) {

	const status = _.get(res, 'status', 'error').toLowerCase()
	const isErr = status !== 'ok'

	if (isErr)
	{
		/** メッセージ取得 */
		const msg = _.get(res, 'message', 'API ERROR')
		throw new ApiError(status, msg) //!EXIT
	}
	else if (_.has(res, 'items'))
		return _.get(res, 'items') //!EXIT
	else
		return true //!EXIT
}


/**
 * 翻訳実行
 */
const multiTranslate = _.debounce(function multiTranslate(tourcode = Translate.helper.getTourcode() )
{
	/** グローバルスコープにTranslateを登録  */
	_.set(Libs.getGlobal(), 'Translate', Translate)

	/** API設定 */
	const apiConfigOption = {
		user: 'tin',
		url:'https://main.dreamjourney.jp/MultiApi/api/multi/multisearch',
	}

	/** 開発時はAddressが違う */
	if( App.isDevelop )
	{
		Object.assign( apiConfigOption, {
			user: 'tin',
			url:'http://172.16.21.112:8084/MultiApi/api/multi/multisearch',
		})
	}

	/** API設定 */
	Translate.apiConfig(apiConfigOption)

	Translate.setDictionaryPath('/eyeswork/multi/TTT/') // 1. 最後のスラッシュはあってもなくても自動判定で処理します
	const lang = Translate.language.getByURL() // 2. 言語識別子は言語用ヘルパー関数を使ってください

	if( lang == 'jp' ) return ; //!EXIT

	const name = tourcode ? `dom_tour_sys/${tourcode}` : null // 3. 商品コード取得はヘルパー関数にも用意しました
	const option = {
		lang: lang.toUpperCase(),
		name,
		log:true
	} // 4. コンソールで翻訳内容をコンソールで確認したい場合はtrue（製品ビルドではログ出力されません）

	Promise.resolve().then(()=>{
		Translate.execute(option) // 4.非同期なのでawaitで実行
	})
}, 600)


/**
 * 翻訳関数のカリー化
 * @description 部分適用で個別の翻訳関数を再定義しやすくするためユーティリティ関数
 * @param {string} dict 
 */
const translate =
	/** @param {string} dict */ dict =>
	/** @param {string} context */ context =>
	/** @param {string} ext */ ext =>
	/** @param {string} lang */ lang =>
	/** @param {Element|Document} container */ container =>
	/** @param {string} tourCode */ tourCode =>
	{
		/** API設定 */
		const apiConfigOption = {
			user: 'tin',
			url:'http://172.16.21.112:8084/MultiApi/api/multi/multisearch',
		}

		/** 開発時はAddressが違う */
		if( App.isDevelop )
		{
			Object.assign( apiConfigOption, {
				user: 'tin',
				url:'http://172.16.21.112:8084/MultiApi/api/multi/multisearch',
			})
		}
		/** API設定 */
		Translate.apiConfig(apiConfigOption)

		/** 辞書ディレクトリ基本パス設定 */
		Translate.setDictionaryPath(dict)
		context = trim(context, '/')
		tourCode = trim(tourCode, '/')

		/** debounceで実行を間引き */
		return _.debounce(()=>
		{
			Translate.execute({
				ext,
				lang,
				container,
				name : `/${context}/${tourCode}`,
				log: true,
			})
		}, 600)
	}

export {
	escAst,
	dispTourTitle,
	getUniquKey,
	fx,
	disp,
	fetchItem,
	fav,
	ApiError,
	countPassenger,
	countAdult,
	countChild,
	countInfant,
	countChildNoSoine,
	multiTranslate,
	translate,
}